import { useTranslation as i18nextUseTranslation } from "react-i18next";

export const useTranslation = i18nextUseTranslation;
